import React, { useState } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import LinePickingService from '../../../services/LinePickingService';
import { translate, showMessageToast } from '../../../utils/util';
import { ENUMS, VISIONS } from '../../../utils/constants';
import { getVision } from '../../../services/auth';
import { onValueChange, validateInputsRequired } from '../../../utils/handleChangeHooks';
import { Button, Card, SelectEquipment, SelectResource, SelectShed, SelectUnit, Breadcrumbs } from '../../../components/UI/ComponentsUI';

const PickingParameters = (props) => {
    let lowering = props.location?.state?.lowering;

    const [model, setModel] = useState({
        resource: props.user.resource || '',
        shed: props.user.shed || '',
        equipment: props.user.equipment || '',
        unitId: props.user.unit || ''
    });

    const onChange = (event) => {
        onValueChange(event, model, setModel);
    };

    const cancel = () => {
        props.history.push({ pathname: lowering ? '../lowering' : '../linePicking' });
    }

    const handleFormKeyDown = (e) => {
        if (e.key === 'Enter') {
            submit();
        }
    }

    const submit = () => {
        if (validateInputsRequired()) {
            let units = props.sheds.find((i) => i.id === model.shed).units;
            units = units.filter((u) => u.unitTypeId === ENUMS.eUnitType.Addressing.value)
            if (!units || units.length === 0) {
                showMessageToast({ html: translate('line-picking:messages.area-no-units'), classes: 'red' });
                return false;
            }
            props.setAreaAdress(units);
            props.history.push({ pathname: lowering ? '../lowering/smallparts' : '../linePicking/smallparts', ...props });
        }
    }

    const subtitlesLinePickingParameters = () => {
        let subtitlesItems = [];
        subtitlesItems = [...subtitlesItems, { icon: "mdi mdi-clipboard-check-outline", label: translate('menu.configuration', 'configuration') }];
        return subtitlesItems;
    }

    return (
        <div>
            <Breadcrumbs id="linePickingParameters" subtitles={subtitlesLinePickingParameters()} />
            <div className="container-fluid" style={{ marginTop: '25px', }}>
                <div className="container">
                    <Card>
                        <div>
                            <form className="col s12" onKeyDown={handleFormKeyDown}>
                                <div id="formConfig" className="row" style={{ marginBottom: '0px' }}>
                                    <div className="input-field col s12">
                                        <SelectShed
                                            modality={ENUMS.eModality.LinePicking.value}
                                            required={getVision() === VISIONS.Fiasa}
                                            value={model.shed}
                                            onChange={onChange}
                                        />
                                    </div>
                                    {
                                        (getVision() === VISIONS.Fiasa || getVision() === VISIONS.Faasa || getVision() === VISIONS.FaasaCKD) && (
                                            <div className="input-field col s12">
                                                <SelectEquipment
                                                    required
                                                    id="equipment"
                                                    name="equipment"
                                                    value={model.equipment}
                                                    onChange={onChange}
                                                />
                                            </div>)
                                    }
                                    {
                                        (getVision() === VISIONS.Fiasa || getVision() === VISIONS.Faasa || getVision() === VISIONS.FaasaCKD) && (
                                            <>
                                                <div className="input-field col s12">
                                                    <SelectUnit
                                                        required
                                                        shedId={model.shed}
                                                        value={model.unitId}
                                                        onChange={onChange}
                                                    />
                                                </div>
                                                {
                                                    getVision() === VISIONS.Fiasa &&
                                                    <div className="input-field col s12">
                                                        <SelectResource
                                                            filterArea
                                                            shedId={model.shed}
                                                            value={model.resource}
                                                            onChange={onChange}
                                                        />
                                                    </div>
                                                }
                                            </>
                                        )
                                    }
                                </div>
                            </form>
                        </div>
                        <div className="row" style={{ paddingTop: '10px' }}>
                            <div className="col s6">
                                <Button full="true" onClick={cancel} text={translate('cancel', 'general')} secundary="true" />
                            </div>
                            <div className="col s6">
                                <Button full="true" onClick={submit} text={translate('confirm', 'general')} />
                            </div>
                        </div>
                    </Card>
                </div>
            </div>
        </div>
    );
}

const mapStateToProps = (state) => {
    return {
        user: state.userReducer.user,
        config: state.configReducer.config,
        filter: state.linePickingReducer.filter,
        sheds: state.configReducer.sheds,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setAreaAdress: (areas) => {
            dispatch(LinePickingService.setArea(areas));
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(PickingParameters));
